import React from 'react'
import Head from 'next/head'
import Navigation from '../../components/Navigation';
import { Parallax } from 'react-parallax';
import Footer from '../../components/Footer';



function PageOBS() {
  return (
    <div>
      <Head>
        <title>Lindle to OBS</title>
        <meta name="description" content="All your links, All at once, All in one place!" />
        <link rel="icon" href="/favicon.ico" />

        {/* Facebook */}
        <meta property="og:title" content="Lindle" />
        <meta property="og:description" content="All your links, All at once, All in one place!" />
        <meta property="og:image" content="/logoText.png" />
        <meta property="og:url" content="https://lindle.vercel.app" />
        <meta property="og:type" content="website" />

        <meta name="twitter:title" content="Lindle" />
        <meta name="twitter:description" content="All your links, All at once, All in one place!" />
        <meta name="twitter:image" content="/logoText.png" />
        <meta name="twitter:card" content="/bannerText.png" />

        {/* pinterest */}
        <meta name="pinterest-rich-pin" content="true" />
      </Head>

      <Navigation />

      <Parallax bgImage="https://images.unsplash.com/photo-1635830625698-3b9bd74671ca?q=80&w=1932&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" bgImageStyle={{ filter: "brightness(0.3)", width: "100%", height: 'fit-content' }} bgImageAlt="Programmers" strength={400}>
        <section className='mobile:p-5 tablet:p-16 text-3xl text-white text-center'>
          <h1 className='mobile:text-3xl tablet:text-8xl my-6'><b>Connecting to OBS</b></h1>
          <p>Enhance your live streaming experience by incorporating QR codes with Lindle. Instantly connect with your audience as QR codes provide a seamless way for viewers to access links without the hassle of typing long URLs. Boost engagement with interactive content, share social media links effortlessly, and maintain a polished and professional appearance in your streams. Elevate your streaming game by making information easily accessible and interactions more dynamic.</p>
        </section>
      </Parallax>

      <main className='mobile:w-full tablet:w-2/3 justify-end self-center mx-auto px-6'>

        {/* <!-- Content Heading --> */}
        <h1 className="mobile:text-lg tablet:text-5xl font-bold my-16">Connect Lindle Links to OBS for QR Codes</h1>

        {/* <!-- Steps Section --> */}
        <section className="grid grid-cols-1 md:grid-cols-3 gap-8">

          {/* <!-- Step 1 --> */}
          <div className="bg-gray-200 p-6 rounded-lg">
            <h2 className="text-xl font-semibold mb-4">Step 1: Get Lindle Browser Extension</h2>
            <p className="mb-4">If you haven&apos;t already, install the Lindle browser extension. You can find it in the Chrome Web Store. This extension allows you to save and organize links easily.</p>
            {/* <!-- Add any relevant images or icons --> */}
          </div>

          {/* <!-- Step 2 --> */}
          <div className="bg-gray-200 p-6 rounded-lg">
            <h2 className="text-xl font-semibold mb-4">Step 2: Generate QR Code from Lindle Link</h2>
            <p className="mb-4">Open Lindle, navigate to the link you want to display, and click on the link. Lindle will provide a QR code option. Generate the QR code for your link.</p>
            {/* <!-- Add any relevant images or icons --> */}
          </div>

          {/* <!-- Step 3 --> */}
          <div className="bg-gray-200 p-6 rounded-lg">
            <h2 className="text-xl font-semibold mb-4">Step 3: Add Lindle QR Code to OBS</h2>
            <p className="mb-4">In OBS, add a new source and choose &quot;Browser.&quot; Paste the Lindle QR code link as the URL. Adjust the size and position as needed. Now, your audience will see the QR code during your stream.</p>
            {/* <!-- Add any relevant images or icons --> */}
          </div>

        </section>

        {/* <!-- Additional Tips Section --> */}
        <section className="my-28">
          <h2 className="text-xl font-semibold mb-4">Additional Tips:</h2>
          <ul className="list-disc pl-8">
            <li>Ensure Lindle extension and OBS are running during your stream.</li>
            <li>Test the QR code before your live session to ensure proper functionality.</li>
            <li>Customize the appearance of the QR code in Lindle to match your stream&apos;s aesthetics.</li>
          </ul>
        </section>
      </main>

      <Footer />
    </div>
  )
}

export default PageOBS